// 📄 components/ui/CatalogoMultiSelect.tsx
// Selector de referencias N:N contra otro catálogo (ej. Programa → varias
// BAdIs, Programa → varias Transacciones) — extiende el patrón de FK único
// ya usado en InterfaceFormModal.tsx (transaccionRefId vía <datalist>) a
// una relación de varios, con chips + un <select> de "agregar". No hay
// autocompletado de texto libre acá: la relación siempre apunta a un id
// real del otro catálogo, nunca a texto sin resolver.
import { X, Plus } from 'lucide-react';

export interface CatalogoOpcion {
  id: string;
  label: string;
}

interface CatalogoMultiSelectProps {
  label: string;
  opciones: CatalogoOpcion[];
  seleccionados: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

export default function CatalogoMultiSelect({ label, opciones, seleccionados, onChange, placeholder }: CatalogoMultiSelectProps) {
  const disponibles = opciones.filter((o) => !seleccionados.includes(o.id));
  const elegidas = seleccionados
    .map((id) => opciones.find((o) => o.id === id))
    .filter((o): o is CatalogoOpcion => !!o);

  const agregar = (id: string) => {
    if (!id || seleccionados.includes(id)) return;
    onChange([...seleccionados, id]);
  };

  const quitar = (id: string) => {
    onChange(seleccionados.filter((s) => s !== id));
  };

  return (
    <div>
      <label className="block text-xs font-medium text-gray-400 mb-1">{label}</label>

      <div className="flex flex-wrap gap-1.5 mb-2">
        {elegidas.map((o) => (
          <span key={o.id} className="flex items-center gap-1 text-[11px] bg-indigo-500/10 text-indigo-300 border border-indigo-500/20 px-2 py-1 rounded-full">
            {o.label}
            <button type="button" onClick={() => quitar(o.id)} className="hover:text-white"><X className="w-3 h-3" /></button>
          </span>
        ))}
        {elegidas.length === 0 && <span className="text-xs text-gray-500">Ninguna todavía.</span>}
      </div>

      {disponibles.length > 0 ? (
        <div className="flex items-center gap-1.5">
          <Plus className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
          <select
            value=""
            onChange={(e) => agregar(e.target.value)}
            className="flex-1 bg-zinc-800 border border-white/10 rounded-lg px-2.5 py-1.5 text-xs text-gray-300"
          >
            <option value="">{placeholder || 'Agregar...'}</option>
            {disponibles.map((o) => (
              <option key={o.id} value={o.id}>{o.label}</option>
            ))}
          </select>
        </div>
      ) : opciones.length === 0 ? (
        <p className="text-[11px] text-gray-500">El otro catálogo todavía está vacío.</p>
      ) : null}
    </div>
  );
}
